export const FETCH_TASKS = 'FETCH_TASKS';
export const CREATE_TASK = 'CREATE_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const DELETE_TASK = 'DELETE_TASK';
export const UPLOAD_TASK_FILE = 'UPLOAD_TASK_FILE';
export const DELETE_TASK_FILE = 'DELETE_TASK_FILE';
